interface IUTMParams {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
}
const ReadUTMQueryParameters = () => {
  let utmParams: IUTMParams = null;
  if (typeof window !== "undefined") {
    const storedParams = localStorage.getItem("utmParams");
    if (storedParams) {
      utmParams = JSON.parse(storedParams);
    }
    if (utmParams) {
      const keys = Object.keys(utmParams);
      const keyValuePairs = keys.map((key) => {
        return encodeURIComponent(key) + "=" + encodeURIComponent(utmParams[key]);
      });
      return keyValuePairs.join("&");
    }
  }
  return null;
};

export default ReadUTMQueryParameters;
